<div class="container">
  <div class="row">
    <div class="col-md-12">
      <header class="header-section-mid for-verticle-middle">
        <h2 class="mid-align">Your Actionables</h2>
      </header>
      <section class="dark-bg-info-card">
        <div class="listing-1">
          <span class="no-bids-text" *ngIf="!actionables.length && !isLoading && openAuctionsCount === 0">
            You have no actionables currently.
          </span>
          <span class="no-bids-text" *ngIf="isLoading">
            Loading Actionables.
          </span>
          <ul>
            <li *ngFor='let action of actionables; let i = index;'>
              <div id="actionable-{{i}}" [routerLink]="action?.link" class="actionableStyle_1">
                {{action?.message}}
                <time class="float-right">{{action?.time | StringToDateFormatPipe: 'bid': 'default'}}</time>
              </div>
            </li>
            <li *ngIf="openAuctionsCount > 0">
              <div id="actionable-open-rfq" [routerLink]="openRfqLink" class="actionableStyle_1">
                You have {{openAuctionsCount}} Open Request for Quotes (RFQ's) available. Click here to Send a Quote.
              </div>
            </li>
          </ul>
        </div>
      </section>
    </div>
  </div>
</div>